import Hero from "../pages/Hero";
import About from "../pages/About";
import Process from "../pages/Process";
import Products from "../pages/Products";
import Projects from "../pages/Projects";
import Reviews from "../pages/Reviews";

export default function Home() {
  return (
    <>
      <Hero />
      <About />
      <Process />
      <div className="h-0" />
      <Products />
      <Projects />
      <Reviews />
    </>
  );
}
